import React, { useState } from "react";
import singingGirl from "../../assets/singingGirl.svg";
import GrassImg from "../../assets/Grass1.svg";
import GrassImg2 from "../../assets/Grass2.svg";
import admissionStar from "../../assets/admissionStar.svg";
import EnquiryModal from "../custom/EnquiryModal";
import CustomButton from "../custom/CustomButton";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";

const ThirdSection = () => {
  const [enquiryModal, setEnquiryModal] = useState(false);
  return (
    <div className="relative flex flex-col py-[2rem] h-[25rem] lg:px-0 px-[2rem] lg:h-[25rem] bg-[#FFE8DC] gap-4 items-center justify-center">
      <div className="z-30">
        <CustomHeading
          text={"A Loving Start To"}
          textSize="60px"
          textAlign="center"
          smTextSize="30px"
          leading="72px"
        />
        <CustomHeading
          text={"Bright "}
          spanText={"Future"}
          spanTextColor="#d31c4f"
          textColor="#d31c4f"
          textSize="60px"
          textAlign="center"
          smTextSize="30px"
          leading="72px"
        />
        <CustomContent
          textSize="20px"
          text={
            "At Mother’s Pride, we don’t just teach — we nurture, celebrate, and inspire."
          }
          textAlign="center"
          marginTop="20px"
          textColor="#D31C4F"
        />
      </div>

      <CustomButton
        text={"Enroll Now"}
        paddingX="20px"
        paddingY="12px"
        handleClick={() => setEnquiryModal(true)}
      />
      {/* absolute things */}
      <img
        src={singingGirl}
        alt="singing Girl"
        className="absolute w-[120px] h-[160px] md:h-[200px] md:w-[197px] lg:h-[347px] z-10 bottom-0 right-0 md:right-[30px]"
      />
      <img
        src={GrassImg}
        alt="Grass"
        className="absolute w-[270px] h-[270px] bottom-0 right-0 z-0"
      />
      <img
        src={GrassImg2}
        alt="Grass"
        className="absolute w-[270px] h-[207px] bottom-[-24px] left-0 z-0"
      />
      <img
        src={admissionStar}
        alt="star"
        className="absolute top-[29%] left-[11%]"
      />
      {enquiryModal && (
        <EnquiryModal
          enquirySource={"Admission"}
          setEnquiryModal={setEnquiryModal}
        />
      )}
    </div>
  );
};

export default ThirdSection;
